const ONES = [
  '', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine',
  'ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen',
  'seventeen', 'eighteen', 'nineteen',
];
const TENS = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
const SCALES = ['', ' thousand', ' million', ' billion'];

function underThousand(n: number): string {
  let out = '';
  if (n >= 100) {
    out += `${ONES[Math.floor(n / 100)]} hundred`;
    n %= 100;
    if (n) out += ' ';
  }
  if (n >= 20) {
    out += TENS[Math.floor(n / 10)]!;
    if (n % 10) out += `-${ONES[n % 10]}`;
  } else if (n > 0) {
    out += ONES[n]!;
  }
  return out;
}

/**
 * Convert a money string (e.g. "1234.56") to the words used on a check:
 * "One thousand two hundred thirty-four and 56/100".
 */
export function amountToWords(value: string): string {
  const [whole = '0', frac = ''] = value.replace(/[$,]/g, '').split('.');
  const cents = (frac + '00').slice(0, 2);
  let dollars = Math.abs(parseInt(whole, 10) || 0);

  let words = '';
  if (dollars === 0) {
    words = 'zero';
  } else {
    const groups: string[] = [];
    let scale = 0;
    while (dollars > 0) {
      const chunk = dollars % 1000;
      if (chunk) groups.unshift(underThousand(chunk) + SCALES[scale]);
      dollars = Math.floor(dollars / 1000);
      scale += 1;
    }
    words = groups.join(' ');
  }

  const capitalized = words.charAt(0).toUpperCase() + words.slice(1);
  return `${capitalized} and ${cents}/100`;
}
